module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAKlBMVEUAAAAJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwJFDwwHpZ/AAAADXRSTlMA4pCAYEBR6vCkcBLADCuA+AAAAGhJREFUGNNjCLwLAaIMQCAL5VwEce7CADZOpxIIQDh3NjCAAITTDTcQyJkANxDIUYCbAeVcT6uFcsAqZEnkXHFxY0hx8YVwLoCt573LIAvkXDa2YlhsbHuXIRBZDxAQyYG7DSNM4J4DAAMXpcayCgqiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/copy.png
// module id = LAQ6
// module chunks = 1